module.exports = __webpack_public_path__ + "img/imgunfine.430a65a0.jpg";